/* eslint-disable max-statements */
import { useNavegate } from 'App/hooks';
import { fulfillmentOrdersRoutes } from 'domains/FulfillmentOrders';
import { DocumentType } from '../../constants';

interface GoToPrintPageProps {
  ids: string[];
  type: DocumentType;
  hasOca?: boolean;
  hasOcaAndNotGeneratedTag?: boolean;
  forceOca?: boolean;
}

function useGoToPrintPage() {
  const { goTo } = useNavegate();

  const goToPrintPage = (params: GoToPrintPageProps) => {
    const { ids, type } = params;

    if (
      params.hasOca &&
      params.hasOcaAndNotGeneratedTag &&
      type === DocumentType.LABEL
    ) {
      goTo(
        `${fulfillmentOrdersRoutes['prePrintOca']}?ids=${encodeURIComponent(
          ids.join(','),
        )}${params.forceOca ? '&overwrite=true' : ''}`,
      );
      return;
    }

    if (params.hasOca && type === DocumentType.LABEL) {
      goTo(
        `${fulfillmentOrdersRoutes[type]}?ids=${encodeURIComponent(
          ids.join(','),
        )}&oca=oca`,
      );
      return;
    }

    goTo(
      `${fulfillmentOrdersRoutes[type]}?ids=${encodeURIComponent(
        ids.join(','),
      )}`,
    );
  };

  return { goToPrintPage };
}

export default useGoToPrintPage;
